import styled from 'styled-components'

export const VideoWrap = styled.div`
  margin-bottom: 20px;
`

